// extracted by mini-css-extract-plugin
export var button = "SliderNavigation-module--button--bbf68";
export var buttonNext = "SliderNavigation-module--buttonNext--3f6cc";
export var buttonPrev = "SliderNavigation-module--buttonPrev--34180";